
import React from "react";
import {
  Checkbox,
  FormControl,
  InputLabel,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Select,
} from "@mui/material";
import { Option } from "../../screens/ServiceAgreements/types";

interface MultiSelectProps {
  label: string;
  options: Option[];
  selected: Option[];
  setSelected: (options: Option[]) => void;
}
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      maxWidth: 200
    },
  },
};
export const MultiSelectDropdown: React.FC<MultiSelectProps> = ({
  label,
  options,
  selected,
  setSelected
}) => {
  const isAllSelected = options.length > 0 && selected.length === options.length;

  const handleChange = (event: any) => {
    const value = event.target.value;
    if (value[value.length - 1] === "all") {
      setSelected(selected.length === options.length ? [] : options);
      return;
    }
    setSelected(value);
  };

  return (
    <FormControl sx={{ minWidth: 150, maxWidth: 150 }} size="small">
      <InputLabel>{label}</InputLabel>
      <Select
        label={label}
        multiple
        value={selected}
        onChange={handleChange}
        renderValue={(selected: Option[]) =>
          selected.map((option: Option) => option.name).join(", ")
        }
        size="small"
        MenuProps={MenuProps}
      >
        <MenuItem value="all">
          <ListItemIcon>
            <Checkbox
              checked={isAllSelected}
              indeterminate={
                selected.length > 0 && selected.length < options.length
              }
            />
          </ListItemIcon>
          <ListItemText primary="Select All" />
        </MenuItem>
        {options.map((option: any) => (
          <MenuItem key={option.id} value={option}>
            <ListItemIcon>
              <Checkbox checked={selected.includes(option)} />
            </ListItemIcon>
            <ListItemText primary={option.name} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
